export const promoCodeHeaders = [
  {
    label: 'id',
    value: 'promocodesId',
    required: true,
    inputType: 'text',
    accessorKey: 'promocodesId',
    Header: 'promocodesId',
    isShowModal: false,
  },

  {
    label: 'Code',
    value: 'code',
    required: true,
    inputType: 'text',
    accessorKey: 'code',
    Header: 'Code',
    isShowModal: true,
  },
  {
    label: 'Amount',
    value: 'amount',
    required: true,
    inputType: 'number',
    accessorKey: 'amount',
    Header: 'Amount',
    isShowModal: true,

  },
  {
    label: 'Amount (TTD)',
    value: 'amountTtd',
    required: false,
    inputType: 'number',
    accessorKey: 'amountTtd',
    Header: 'Amount (TTD)',
    // This is a display-only column for vouchers; not shown in modal
    isShowModal: false,

  },
  {
    label: 'Validity',
    value: 'validity',
    required: true,
    inputType: 'date',
    accessorKey: 'validity',
    Header: 'Validity',
    isShowModal: true,

  },
  {
    label: 'Status',
    value: 'status',
    inputType: 'toggle',
    accessorKey: 'status',
    Header: 'Status',
    isShowModal: true,

  },
  {
    label: 'Redeemed',
    value: 'isRedeemed',
    accessorKey: 'isRedeemed',
    Header: 'Redeemed',
    inputType: 'toggle',
    isShowModal: false,
  },
  {
    label: 'Action',
    value: 'action',
    accessorKey: 'action',
    Header: 'Action',
    isShowModal: false,

  }
];




export const isDateValid = (validityDate) => {
  if (!validityDate) return false;
  
  try {
    const today = new Date().toISOString().split('T')[0];
    const inputDate = new Date(validityDate).toISOString().split('T')[0];
    return inputDate >= today;
  } catch (error) {
    return false;
  }
};